module.exports = __webpack_public_path__ + "static/media/graphicTV@1x.a00c795b.png";